function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M8 15.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z",
  stroke: "#A0AFBE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 10.5s1.167 1 3.5 1 3.5-1 3.5-1",
  stroke: "#A0AFBE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.5 7.5a1 1 0 100-2 1 1 0 000 2zM10.5 7.5a1 1 0 100-2 1 1 0 000 2z",
  fill: "#A0AFBE"
});
function SvgEmojiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}
export default SvgEmojiIcon;